import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>©2016-2025 Definitive Business Solutions, Inc. All Rights Reserved</Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
              U.S. Patent Nos. 10,268,977; 10,366,361; 10,417,590
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
